var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5832 19.25V17.4167C15.5832 16.4442 15.1969 15.5116 14.5092 14.8239C13.8216 14.1363 12.889 13.75 11.9165 13.75H4.58317C3.61071 13.75 2.67808 14.1363 1.99045 14.8239C1.30281 15.5116 0.916504 16.4442 0.916504 17.4167V19.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25016 10.0833C10.2752 10.0833 11.9168 8.44171 11.9168 6.41667C11.9168 4.39162 10.2752 2.75 8.25016 2.75C6.22512 2.75 4.5835 4.39162 4.5835 6.41667C4.5835 8.44171 6.22512 10.0833 8.25016 10.0833Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0835 19.25V17.4166C21.0829 16.6042 20.8125 15.815 20.3147 15.1729C19.817 14.5308 19.1201 14.0722 18.3335 13.8691",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 2.86914C15.4552 3.07108 16.1543 3.52978 16.6535 4.17293C17.1527 4.81607 17.4237 5.60707 17.4237 6.42122C17.4237 7.23538 17.1527 8.02638 16.6535 8.66952C16.1543 9.31266 15.4552 9.77136 14.6665 9.97331",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.1cee2a1143f6441cee560785a867e55e.svg";
export { ForwardRef as ReactComponent };